export default {
  'business-growth': 'Grow your business',
}
